import api from "../core/api";

const controllerName = "DokumanYonetimSistemi";

const DysApi = api.injectEndpoints({
    endpoints: (builder) => ({
        CHKOlustur: builder.mutation<string, void>({
            query: () => {
                return {
                    url: controllerName + "/CHKOlustur",
                    method: "GET"
                }
            }
        })
    })
});

export const {
    useCHKOlusturMutation
} = DysApi;